import React, { PropTypes } from 'react';
import { Field, Fields } from 'redux-form';
import { CheckBoxInputField, CheckBoxField } from 'common/components/form_fields';
import { getNegativeFeedbackQuestions } from 'entries/utils';

const NegativeFeedback = ({ handleSubmit, onSubmit, onHide, subcatSlug }) => {
  const questions = getNegativeFeedbackQuestions(subcatSlug);

  return (
    <form className="entry-feedback-form" onSubmit={handleSubmit(onSubmit)}>
      <h3>What didn't you like about it?</h3>
      { questions.map((question, i) => (
      <Field key={i} component={CheckBoxField} name={question.name} label={question.label} />
      )) }
      <Fields
        names={['feedbackTextCheckbox', 'feedback']}
        values={{ feedback: '' }}
        component={CheckBoxInputField}
      />
      <div className="form-actions">
        <button type="submit" className="btn btn-block btn-primary btn-md">Send Feedback</button>
        <button type="button" className="btn btn-block btn-text btn-md" onClick={onHide}>Cancel</button>
      </div>
    </form>
  );
};

NegativeFeedback.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  subcatSlug: PropTypes.string,
};

export default NegativeFeedback;



// WEBPACK FOOTER //
// ./entries/components/negative_feedback.jsx